// extracted by mini-css-extract-plugin
export default {"GalleryItem":"Gallery_GalleryItem__gweIN"};